import { Alert, Box, Button, Typography } from '@mui/material';
import DevicePage from '../DevicePage';
import useDeviceData from '../../hooks/useDeviceData';
import { HomeAddressTile } from '../Maps/LocationTiles';
import DeviceNumbers from './DeviceNumbers';
import { isSmartConnectUnit } from '../../utils/smartConnect';

function CustomerDetails({ unit }) {
    const { data, status, retry } = useDeviceData(unit);
    return <Box sx={{ maxWidth: 800, mx: 'auto', px: 1, pb: 2 }}>
        <Typography component="h1" variant="h5" sx={{ mb: 2 }}>Customer</Typography>
        {!unit?.UnitSerNum ? <Alert severity="info">Select a customer to view their information.</Alert>
            : status === 'loading' ? <Typography role="status">Loading customer information…</Typography>
                : status === 'error' ? <Alert severity="error" action={<Button color="inherit" onClick={retry}>Retry</Button>}>Unable to load customer information. Check your connection and try again.</Alert>
                    : <>
                        <Box sx={{ mb: 2 }}><HomeAddressTile homeAddress={data?.homeAddress || unit.HomeAddress}
                            location={data?.lastKnownLocation} isUsingHomeLocation={data?.useHomeLocation} /></Box>
                        {isSmartConnectUnit(unit) && <DeviceNumbers unit={unit} numbers={data?.numbersToBeAwareOf || {}} />}
                    </>}
    </Box>;
}

export default function CustomerInformation() {
    return <DevicePage content={CustomerDetails} />;
}
